module.exports = __webpack_public_path__ + "static/logo_color.c32d99ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo_color.png
// module id = 100
// module chunks = 168707334958949